const PAYMENT_METHOD_LABELS = {
  cp: "Card Reader",
  cnp: "Online",
  moto: "Virtual Terminal",
  cash: "Cash",
  cf: "Card on File",
  gift_card: "Gift Card",
  check: "Check",
  standalone_terminal: "Standalone Terminal",
};

export function pmCodeLabel(pmCode) {
  const code = String(pmCode || "").toLowerCase();
  if (PAYMENT_METHOD_LABELS[code]) return PAYMENT_METHOD_LABELS[code];
  if (!pmCode) return "Unknown";
  return code
    .split(/[_\s-]+/)
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}
